import { Grid } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { useField } from "formik";
import React from "react";

const EntrySwitch = ({
  name,
  label,
  // ...
  labelPlacement = "start",
  sx = {},
  // ...
  xs = 12,
  md = 6,
  // ...
  disabled
}) => {
  const [field, meta, helpers] = useField({ name });
  // ...
  return (
    <Grid item xs={xs} md={md}>
      <FormControlLabel
        className="Entry EntrySwitch"
        label={label}
        labelPlacement={labelPlacement}
        sx={{ ...sx }}
        control={
          <Switch
            checked={field.value}
            onChange={(e) => {
              helpers.setValue(e.target.checked);
            }}
            onBlur={field.onBlur}
            // ...
            disabled={disabled}
          />
        }
      />
    </Grid>
  );
};

export default EntrySwitch;
